<template>
  <div>
    <div>
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Báo cáo quỹ xu"
            :link="[
              // {
              //   text: 'Báo cáo suất ăn',
              //   href: '../meal-report'
              // }
            ]"
          />
        </div>
        <div v-if="onFiltered && !loading">
          <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
            <v-icon left>mdi-file-excel</v-icon> Xuất Excel
          </v-btn>
        </div>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <ReportFilter @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card
        v-if="!onFiltered"
        class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16 px-6"
        outlined
      >
        Vui lòng cung cấp thông tin ở trên, sau đó ấn [Tìm kiếm] để xem Báo cáo quỹ xu
      </v-card>
      <v-card v-show="onFiltered" outlined class="mx-4 elevation-0">
        <ReportTable ref="table" :filterLoading="loading" />
      </v-card>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ReportFilter from '@/modules/mealReport/MealReportFilter.vue'
import ReportTable from '@/modules/StudentCreditReport/components/ReportTable.vue'
import { mapActions } from 'vuex'
import { get } from 'lodash'
import utils from '@/plugins/utils'
import moment from 'moment'
export default {
  components: { ReportFilter, ReportTable, Breadcrumbs },
  data() {
    return {
      loading: false,
      onFiltered: false
    }
  },
  methods: {
    ...mapActions({
      fetchStudentCreditReports: 'studentCredit/fetchStudentCreditReports',
      count: 'studentCredit/fetchCount'
    }),
    async onFilterChange(query) {
      this.loading = true
      try {
        this.onFiltered = true
        const date = get(query, 'date', null)
        if (date && moment(date).isValid()) {
          const timeGte = moment(date).startOf('month')
          const timeLte = moment(date).endOf('month')
          const params = {
            currentClass: query.class,
            grade: query.grade,
            id: query.student,
            time_gte: timeGte.toISOString(),
            time_lte: timeLte.toISOString(),
            _sort: 'nameToNumber:asc'
          }
          await this.fetchStudentCreditReports({ ...params })
        } else {
          this.$alert.error('Thiếu khoảng thời gian')
        }
      } catch (error) {
        this.$alert.error('Không tải được dữ liệu. Vui lòng thử lại')
      } finally {
        this.loading = false
      }
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.table.headers]
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'actions')
        const content = [...this.$refs.table.studentCreditReports]
        const excelContent = content.map(v => ({
          currentClass: v.currentClass,
          index: v.index.toLocaleString('en-US'),
          totalIn: v.totalIn.toLocaleString('en-US'),
          student: get(v, 'student.name', 'Chưa có tên'),
          dob: moment(get(v, 'student.dob', '')).format('DD/MM/YYYY'),
          totalInIsCounted: v.totalInIsCounted.toLocaleString('en-US')
        }))
        const month = moment().month() + 1
        utils.exportExcel(excelContent, excelHeader, `BaoCaoQuyXu_Thang${month}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
